import React from 'react';
import { useSelector } from 'react-redux';

import SectionViewTracker from 'dpl/common/components/SectionViewTracker';
import Divider from 'dpl/components/BreederProfile/mobile/components/shared/Divider';
import PuppyPricing from 'dpl/components/BreederProfile/mobile/components/shared/PuppyPricing';
import WhatsIncluded from 'dpl/components/BreederProfile/mobile/components/shared/WhatsIncluded';

export default function BreederProfilePricingSectionContainer() {
  const { analyticsPageName, breederProfileId } = useSelector(
    ({ server }) => server
  );

  return (
    <div className="BreederProfilePricingSectionContainer container-xxl bg-sand pv8">
      <SectionViewTracker
        name={analyticsPageName}
        category="breeder-profile-tab-about-pricing"
        properties={{ breeder_profile_id: breederProfileId }}
      >
        <PuppyPricing />
      </SectionViewTracker>

      <Divider containerClassName="mv6" />
      <WhatsIncluded />
    </div>
  );
}
